/**Helper function to append a js script to the document. */
export const appendScript = (scriptToAppend) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = scriptToAppend;
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`Failed to load script: ${scriptToAppend}`));
    document.body.appendChild(script);
  });
};
